import Subheader from './header/Subheader';
import MiddleSchoolSubheader from './MiddleSchoolSubheader';
import { useSelectedClassroom } from '../Classrooms';
import { History, Location } from 'history';

// The own-props contract shared by Subheader and MiddleSchoolSubheader
// (their remaining props come from their redux connectors).
interface Props {
  history: History;
  location: Location;
  isAuthenticated: boolean;
}

const SubheaderRedirect = (props: Props): JSX.Element => {
  const selection = useSelectedClassroom();

  // The subheader is classroom navigation, so it's useless without a selected
  // classroom - render nothing while loading and when the teacher has none.
  if (selection.status !== 'ready') {
    return <></>;
  }

  if (parseInt(selection.classroom.grade) > 5) {
    return <MiddleSchoolSubheader {...props} />;
  }

  return <Subheader {...props} />;
};

export default SubheaderRedirect;
